import { EventEmitter, Injectable } from '@angular/core';
import { User } from '../_models';
import { StatsSummary } from '../_models/statsSummary';
import { Subscription } from '../_models/sub';

@Injectable()
export class EventsService {
    openProfilEvent: EventEmitter<User> = new EventEmitter<User>();
    openMeDispatchEvent: EventEmitter<User> = new EventEmitter<User>();
    closeMeDispatchEvent: EventEmitter<User> = new EventEmitter<User>();
    closeWidgetEvent: EventEmitter<void> = new EventEmitter<void>();
    openWidgetEvent: EventEmitter<void> = new EventEmitter<void>();
    updateVisitsEvent: EventEmitter<{count:number, reset:boolean}> = new EventEmitter<{count:number, reset:boolean}>();
    updateFavoritesEvent: EventEmitter<void> = new EventEmitter<void>();
    updateStatsEvent: EventEmitter<StatsSummary> = new EventEmitter<StatsSummary>();
    openLigthBoxEvent: EventEmitter<string> = new EventEmitter<string>();
    closeLigthBoxEvent: EventEmitter<void> = new EventEmitter<void>();
    openVideoBoxEvent: EventEmitter<string> = new EventEmitter<string>();
    closeVideoBoxEvent: EventEmitter<void> = new EventEmitter<void>();
    openUpgradeVipPromoEvent: EventEmitter<{subscribed:boolean, subscription:Subscription}> = new EventEmitter<{subscribed:boolean, subscription:Subscription}>();
    openUpgradeVipPixelEvent: EventEmitter<{subscribed:boolean, subscription:Subscription}> = new EventEmitter<{subscribed:boolean, subscription:Subscription}>();
    openDowngradeVipPromoEvent: EventEmitter<void> = new EventEmitter<void>();
    openDowngradeVipPixelEvent: EventEmitter<void> = new EventEmitter<void>();
    openPixelSubscribePromptEvent: EventEmitter<void> = new EventEmitter<void>();
    updatePixelPositionEvent: EventEmitter<string> = new EventEmitter<string>();

    /**
     * Constructor
     */
    constructor() {}

    /**
     * Open user profil
     */
    public openProfil(user: User) {
        this.openProfilEvent.emit(user);
    }

    /**
     * Open me dispatch
     */
    public openMeDispatch() {
        this.openMeDispatchEvent.emit();
    }

    /**
     * Close me dispatch
     */
    public closeMeDispatch() {
        this.closeMeDispatchEvent.emit();
    }

    /**
     * Open infos widget
     */
    public openInfosWidget() {
        this.openWidgetEvent.emit();
    }

    /**
     * Close infos widget
     */
    public closeInfosWidget() {
        this.closeWidgetEvent.emit();
    }

    /**
     * Close widget
     */
    public closeWidget() {
        this.closeWidgetEvent.emit();
    }

    /**
     * Update new visits count
     */
    public updateNewVisitsCount(count: number, reset:boolean = false) {
        this.updateVisitsEvent.emit({count:count, reset:reset});
    }

    /**
     * Update favorites
     */
    public updateFavorites() {
        this.updateFavoritesEvent.emit();
    }

    /**
     * Update stats
     */
    public updateStats(stats: StatsSummary) {
        this.updateStatsEvent.emit(stats);
    }

    /**
     * Open lightbox
     */
    public openLightbox(url:string) {
        this.openLigthBoxEvent.emit(url);
    }

    /**
     * Close lightbox
     */
    public closeLightbox() {
        this.closeLigthBoxEvent.emit();
    }

    /**
     * Open videobox
     */
    public openVideobox(url:string) {
        this.openVideoBoxEvent.emit(url);
    }

    /**
     * Close videobox
     */
    public closeVideobox() {
        this.closeVideoBoxEvent.emit();
    }
}
